<div>
  @if (invoiceId && tenantId) {
    <app-checkout [invoiceId]="invoiceId" [tenantId]="tenantId"></app-checkout>
  }
</div>
